<div id="wrap" *ngIf="questions">

  <div id="numberWrap">
    <div class="circle active fontSize16">
      1
    </div>

    <div class="line"></div>

    <div class="circle active fontSize16">
      2
    </div>

    <div class="line"></div>

    <div class="circle inactive fontSize16">
      3
    </div>
  </div>

  <!--<img id="taskBtn" class="fontSize16 imgAble" (click)="taskBookOut($event)" src="{{assetsRoute}}/picture/casepracticeauthorization/task.png" />-->
  <div id="btnwrap">
  	<div id="taskBtn" class="fontSize16 imgAble"  (click)="taskBookOut($event)">任务书</div>
  </div>
  <div id="taskBookBox" [innerHtml]="taskBook" class="fontSize16 lineHeight24">
  </div>

  <div id="shade"></div>

  <div id="closeBtn" (click)="closeTip($event)"></div>

  <div id="questionWrap" *ngIf="!tellWrapShow">
     <div id="tip1" class="fontSize14">
       判断一下，下面哪些事我得交代明白，哪些事我不该说。
     </div>

    <div id="questionCard">
      <div id="questionContent" class="fontSize16">
        {{currentQuestion}}
      </div>

      <div class="choice" id="choice1" (click)="onOptionClick(0)"
           [ngClass]="{'choiceSelected':currentOption == '要交代','choiceNotSelected':currentOption != '要交代'}">
        <img src="{{assetsRoute}}/picture/casepracticeauthorization/left1.png" alt="" class="leftPic" *ngIf="currentOption == '要交代'">
        <img src="{{assetsRoute}}/picture/casepracticeauthorization/left2.png" alt="" class="leftPic" *ngIf="currentOption != '要交代'">
        <div class="choiceWord fontSize16"
             [ngClass]="{'choiceWordSelected':currentOption == '要交代','choiceWordNotSelected':currentOption != '要交代'}">
          要交代
        </div>
      </div>

      <div class="choice" id="choice2" (click)="onOptionClick(1)"
           [ngClass]="{'choiceSelected':currentOption == '不该说','choiceNotSelected':currentOption != '不该说'}">
        <img src="{{assetsRoute}}/picture/casepracticeauthorization/right1.png" alt="" class="rightPic" *ngIf="currentOption == '不该说'">
        <img src="{{assetsRoute}}/picture/casepracticeauthorization/right2.png" alt="" class="rightPic" *ngIf="currentOption != '不该说'">
        <div class="choiceWord fontSize16"
             [ngClass]="{'choiceWordSelected':currentOption == '不该说','choiceWordNotSelected':currentOption != '不该说'}">
          不该说
        </div>
      </div>

      <img [@answerShowAnimation] src="{{assetsRoute}}/picture/casepracticeauthorization/right.png" alt="" id="rightPic" *ngIf="currentOption == currentRightAnswer&&showAnswer">
      <img [@answerShowAnimation] src="{{assetsRoute}}/picture/casepracticeauthorization/wrong.png" alt="" id="wrongPic" *ngIf="currentOption != currentRightAnswer&&showAnswer">
    </div>

    <div id="tip2" class="fontSize14" *ngIf="questionBtnMode == 3">
      接下来我们整理下，哪些事需要交代明白。
    </div>

    <div id="questionBtn" class="fontSize18" (click)="onQuestionBtnClick()"
         [ngClass]="{'questionBtnAble':currentOption != '','questionBtnDisable':currentOption == ''}">
      <span *ngIf="questionBtnMode==1">看看我选对了吗</span>
      <span *ngIf="questionBtnMode==2">下一句</span>
      <span *ngIf="questionBtnMode==3">进入讨论准备表</span>
    </div>
  </div>

  <div id="tellWrap" [@tellWrapAnimation]="tellWrapShow ? 'showTellWrap' : 'hideTellWrap'">
    <div id="tellBox" class="fontSize16">
      <div id="tellTitle" class="fontSize18">
         <h3>这些事，我得交代明白</h3>
      </div>
      <div id="tellContent" class="fontSize16" [innerHtml]="tell"></div>
    </div>

    <div id="tellBtn" class="fontSize16" (click)="goToMain()">
      找高朗，准备授权
    </div>
  </div>



</div>



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-question/case-practice-authorization-question.component.html